import { create } from 'zustand';
import type { LucideIcon } from 'lucide-react';
import type { SpeedDialAction } from './speedDialModel';

/**
 * QuickCreate state shared by the floating button (QuickCreateFab), the host
 * (QuickCreate.tsx: forms, `N` key) and the command palette.
 */
export type QuickCreateAction = SpeedDialAction;

export interface QuickCreateItem {
  id: QuickCreateAction;
  label: string;
  icon: LucideIcon;
  /** Second line: what the form will be pre-filled with. */
  hint?: string;
}

interface QuickCreateState {
  open: boolean;
  /** The floating button (focus returns here; forms remember it as their opener). */
  anchor: HTMLElement | null;
  /** Set by <QuickCreateHost />: runs a chosen action. */
  runner: ((action: QuickCreateAction) => void) | null;
  openMenu: () => void;
  closeMenu: () => void;
}

export const useQuickCreateStore = create<QuickCreateState>((set, get) => ({
  open: false,
  anchor: null,
  runner: null,
  openMenu: () => set({ open: true }),
  closeMenu: () => { if (get().open) set({ open: false }); },
}));

/** Open the speed-dial (focus moves to its first item). */
export function openQuickCreate() {
  useQuickCreateStore.getState().openMenu();
}

/** Run an action directly (the command palette). */
export function runQuickCreate(action: QuickCreateAction) {
  useQuickCreateStore.getState().runner?.(action);
}
